import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import "./App.css";

const offersData = [
  { id: 1, title: "Stay Tuned For Our Upcoming Offers!" },
];

const reviewsData = [
  { name: "Mazen Abdo",      rating: 5, text: "Very friendly and professional staff. You can always find what you want here 😊",                                                                                                                                                             date: "Recent",       mapUrl: "https://maps.app.goo.gl/L4bvQYQh8wRMhRVa8" },
  { name: "Taleena Sheshe",  rating: 5, text: "Extremely clean and excellent service.",                                                                                                                                                                                                      date: "Recent",       mapUrl: "https://maps.app.goo.gl/EdiLXx3ip2XZZYAF8" },
  { name: "Samer Tallauze",  rating: 5, text: "This pharmacy is one of the best in Jordan in terms of customer service and providing helpful advice and guidance. They are very attentive to their customers and deserve all the best. All respect and appreciation.",                         date: "Recent",       mapUrl: "https://maps.app.goo.gl/FqqB5oNiZT8MwSWh9" },
  { name: "Adham",           rating: 5, text: "I often hear about their excellent treatment and efforts with patients... May their efforts be blessed.",                                                                                                                                      date: "Recent",       mapUrl: "https://maps.app.goo.gl/Xhss4ujVStX73RhR9" },
  { name: "Husam Musa",      rating: 5, text: "A distinguished pharmacy; all its staff are excellent, possess a good understanding of the situation, and provide outstanding service.",                                                                                                       date: "Recent",       mapUrl: "https://maps.app.goo.gl/DndqEU98BSxAWM259" },
  { name: "Tareq Tareq",     rating: 5, text: "The staff there are very knowledgeable and cooperative, especially the girl who works there, Neveen. I consider her almost my only destination for buying medicines and medical advice.",                                                      date: "Recent",       mapUrl: "https://maps.app.goo.gl/L4bvQYQh8wRMhRVa8" },
];

const jobsData = [
  { title: "Licensed Pharmacist",   type: "Full-Time",            location: "Multiple Branches", icon: "💊" },
  { title: "Sales Person",          type: "Full-Time / Part-Time", location: "Multiple Branches", icon: "🤝" },
  { title: "Delivery & Logistics",  type: "Full-Time",            location: "Amman",             icon: "🚗" },
];

const marqueeItems = [
  "Deir-Ghbar", "7th Circle", "Tla Al Ali", "Mecca Street",
  "Al Sahaba St.", "Jubeiha", "Sigma Khalda",
  "Trusted Since 2002", "7 Locations", "Open Late Every Night",
];

function preloadImages(urls) {
  urls.forEach((u) => {
    if (!u) return;
    const img = new Image();
    img.decoding = "async"; img.loading = "eager"; img.referrerPolicy = "no-referrer"; img.src = u;
  });
}

function isBranchOpen(hours) {
  if (!hours) return false;
  const now = new Date();
  const currentHour = now.getHours() + now.getMinutes() / 60;
  const [openStr, closeStr] = hours.toLowerCase().split("-").map((s) => s.trim());
  const parseHour = (str) => {
    let hour = parseInt(str);
    if (str.includes("pm") && hour !== 12) hour += 12;
    if (str.includes("am") && hour === 12) hour = 0;
    return hour;
  };
  const openHour = parseHour(openStr);
  const closeHour = parseHour(closeStr);
  if (closeHour < openHour) return currentHour >= openHour || currentHour < closeHour;
  return currentHour >= openHour && currentHour < closeHour;
}

function StarRating({ count = 5 }) {
  return (
    <div className="stars">
      {Array.from({ length: count }).map((_, i) => (
        <span key={i} className="star">★</span>
      ))}
    </div>
  );
}

export default function BabHittaPharmacyWebsite() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [theme, setTheme] = useState("light");
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
  }, [sidebarOpen]);

  useEffect(() => {
    const stored = localStorage.getItem("theme");
    if (stored === "light" || stored === "dark") {
      setTheme(stored);
      document.documentElement.setAttribute("data-theme", stored);
      return;
    }
    const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
    const initial = prefersDark ? "dark" : "light";
    setTheme(initial);
    document.documentElement.setAttribute("data-theme", initial);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));

  useEffect(() => {
    const handleScroll = () => {
      const offset = Math.min(window.scrollY * 0.3, 120);
      document.documentElement.style.setProperty("--hero-offset", `${offset}px`);
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0) setScrollProgress((window.scrollY / total) * 100);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const branchData = [
    { name: "Deir-Ghbar", phone: "06 592 9474", mapUrl: "https://maps.app.goo.gl/AjxsKhUZ95qF6T4C7", hours: "8am - 2am", image: "https://i.postimg.cc/DZFQW9bn/Whats-App-Image-2025-06-15-at-9-22-43-PM.jpg" },
    { name: "7th Circle", phone: "06 585 1850", mapUrl: "https://maps.app.goo.gl/ugRxhbamAmJ4wXDz8", hours: "8am - 12am", image: "https://i.postimg.cc/BZg01Q29/Whats-App-Image-2025-06-16-at-4-27-32-PM.jpg" },
    { name: "Tla Al Ali", phone: "06 569 9941", mapUrl: "https://maps.app.goo.gl/4GYhRDqCf3ynUc766", hours: "8am - 1am", image: "https://i.postimg.cc/kgDd1pMW/Whats-App-Image-2026-01-22-at-2-07-06-AM.jpg" },
    { name: "Mecca Street", phone: "06 552 5513", mapUrl: "https://maps.app.goo.gl/NeMW3owNjDQqnstP9", hours: "8am - 12am", image: "https://i.postimg.cc/rpDffDxX/Whats-App-Image-2025-06-13-at-8-48-10-PM.jpg" },
    { name: "Al Sahaba St.", phone: "06 420 6495", mapUrl: "https://maps.app.goo.gl/KbMv1K3Xym2ebcwq5", hours: "8am - 3am", image: "https://i.postimg.cc/ydGCbzjh/Whats-App-Image-2026-05-30-at-3-51-46-AM.jpg" },
    { name: "Jubeiha", phone: "06 535 3598", mapUrl: "https://maps.app.goo.gl/38CGS9kjw2bW9g4j8", hours: "8am - 12am", image: "https://i.postimg.cc/zfRSvTMN/Whats-App-Image-2025-06-25-at-11-32-51-PM.jpg" },
    { name: "Sigma — Khalda", phone: "06 535 4001", mapUrl: "https://maps.app.goo.gl/Bh6vJ3VnpwGPSXND6", hours: "8am - 12am", image: "https://i.postimg.cc/kG5wV24N/Whats-App-Image-2025-01-25-at-11-58-05-AM.jpg" },
  ];

  useEffect(() => {
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 0));
    idle(() => preloadImages(branchData.map((b) => b.image)));
  }, []);

  const contactList = [
    { label: "CEO: Dr Nedal Al-Muhtaseb", value: "+962795550984" },
    { label: "HR: Dr Rana Kallajo", value: "+962781555855" },
    { label: "Orders: Dr Ekram Khdair", value: "+962792708413" },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) { el.scrollIntoView({ behavior: "smooth" }); setSidebarOpen(false); }
  };

  return (
    <div className="site-wrapper">
      <div className="scroll-progress" style={{ width: `${scrollProgress}%` }} />

      <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label="Menu">
        {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      <div className={`overlay ${sidebarOpen ? "show" : ""}`} onClick={() => setSidebarOpen(false)} />

      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-brand">
          <div className="brand-mark">Bab Hitta</div>
          <div className="brand-sub">Pharmacy</div>
          <div className="brand-tagline">Trusted care across Amman</div>
        </div>
        <nav className="nav-group">
          {[
            ["about","📖","About Us"],
            ["branches","📍","Our Branches"],
            ["offers","🔥","Offers"],
            ["reviews","⭐","Reviews"],
            ["careers","💼","Careers"],
            ["socials","📱","Socials"],
            ["contact","📞","Contact"],
          ].map(([id, icon, label]) => (
            <button key={id} onClick={() => scrollTo(id)}>
              <span className="nav-icon">{icon}</span> {label}
            </button>
          ))}
        </nav>
        <div className="theme-block">
          <div className="theme-label">Appearance</div>
          <button className="theme-toggle" onClick={toggleTheme}>
            <span className="left">☀️</span>
            <div className="track" />
            <span className="right">🌙</span>
            <div className="thumb">{theme === "light" ? "☀️" : "🌙"}</div>
          </button>
        </div>
      </aside>

      <main className="main-content">

        {/* ─── HERO ─── */}
        <section className="hero-box">
          <div className="hero-content">
            <motion.div className="hero-badge"
              initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.22,1,0.36,1] }}>
              7 Locations Across Amman
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.85, delay: 0.1, ease: [0.22,1,0.36,1] }}>
              Bab Hitta<br />Pharmacy
            </motion.h2>
            <motion.div className="hero-divider"
              initial={{ scaleX: 0, originX: 0 }} animate={{ scaleX: 1 }}
              transition={{ duration: 0.7, delay: 0.38, ease: [0.22,1,0.36,1] }} />
            <motion.p
              initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.65, delay: 0.5, ease: [0.22,1,0.36,1] }}>
              Trusted pharmaceutical care, close to where you live.
            </motion.p>
            <motion.button className="visit-btn" onClick={() => scrollTo("branches")}
              initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.55, delay: 0.65, ease: [0.22,1,0.36,1] }}
              whileHover={{ scale: 1.04, y: -2 }} whileTap={{ scale: 0.97 }}>
              Find a Branch
            </motion.button>
          </div>
          <motion.div className="scroll-hint"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }}
            transition={{ delay: 1.4, duration: 0.6 }}>
            <div className="scroll-hint-dot" />
          </motion.div>
        </section>

        {/* ─── MARQUEE ─── */}
        <div className="marquee-strip" aria-hidden="true">
          <div className="marquee-track">
            {[...marqueeItems, ...marqueeItems].map((item, i) => (
              <span key={i} className="marquee-item">
                <span className="marquee-dot">◆</span> {item}
              </span>
            ))}
          </div>
        </div>

        {/* ─── ABOUT ─── */}
        <section id="about">
          <motion.h3
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.55 }}>
            📖 About Us
          </motion.h3>
          <h4 className="about-subheading">Dedicated to Wellness</h4>
          <p>
            At Bab Hitta Pharmacy, we bring trusted pharmaceutical care to every
            corner of Amman. With seven convenient branches, our experienced
            pharmacists deliver personalized advice, genuine medicines, and health
            solutions tailored to your needs. From everyday essentials to specialty
            treatments, we're committed to keeping our community healthy — one
            prescription at a time.
          </p>
        </section>

        {/* ─── BRANCHES ─── */}
        <section id="branches">
          <motion.h3
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.55 }}>
            📍 Our Branches
          </motion.h3>
          <div className="branches-grid">
            {branchData.map((branch, i) => {
              const openNow = isBranchOpen(branch.hours);
              return (
                <motion.div key={i} className="branch-card"
                  initial={{ opacity: 0, y: 36 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.45, delay: i * 0.04 }}>

                  {/* Full bleed image */}
                  <div className="bc-img">
                    <img src={branch.image} alt={branch.name} loading="lazy" />
                    <div className="bc-img-overlay" />
                    <span className={`bc-status ${openNow ? "open" : "closed"}`}>
                      <span className="bc-status-dot" />
                      {openNow ? "Open" : "Closed"}
                    </span>
                  </div>

                  {/* Info */}
                  <div className="bc-info">
                    <div className="bc-top">
                      <h4 className="bc-name">Bab Hitta<br /><strong>{branch.name}</strong></h4>
                    </div>
                    <div className="bc-meta">
                      <span>🕒 {branch.hours}</span>
                      <span>📞 {branch.phone}</span>
                    </div>
                    <div className="bc-actions">
                      <a href={`tel:${branch.phone.replace(/\s/g,"")}`} className="bc-btn-call">Call</a>
                      <a href={branch.mapUrl} target="_blank" rel="noopener noreferrer" className="bc-btn-dir">Directions</a>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </section>

        {/* ─── OFFERS ─── */}
        <section id="offers">
          <h3>🔥 Offers</h3>
          <div className="grid" style={{ marginTop: 36 }}>
            {offersData.map((offer, i) => (
              <motion.div key={offer.id} className="offer-card"
                whileHover={{ scale: 1.02 }}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.4 }}>
                <h4>{offer.title}</h4>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ─── REVIEWS ─── */}
        <section id="reviews" className="reviews-section">
          <motion.h3
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.55 }}>
            ⭐ What People Say
          </motion.h3>

          <motion.div className="reviews-summary"
            initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <div className="reviews-score">5.0</div>
            <div className="reviews-summary-right">
              <StarRating count={5} />
              <div className="reviews-count">Based on Google Reviews</div>
            </div>
          </motion.div>

          <div className="reviews-grid">
            {reviewsData.map((review, i) => (
              <motion.div key={i} className="review-card"
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.42, delay: i * 0.06 }}>
                <div className="review-top">
                  <div className="review-avatar">{review.name[0]}</div>
                  <div>
                    <div className="review-name">{review.name}</div>
                    <div className="review-date">{review.date}</div>
                  </div>
                  <a href={review.mapUrl} target="_blank" rel="noopener noreferrer" className="google-logo-link">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                      alt="Google" className="google-logo" />
                  </a>
                </div>
                <StarRating count={review.rating} />
                <p className="review-text">"{review.text}"</p>
              </motion.div>
            ))}
          </div>

          <motion.a
            href="https://maps.app.goo.gl/L4bvQYQh8wRMhRVa8"
            target="_blank" rel="noopener noreferrer"
            className="see-all-reviews"
            initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
            viewport={{ once: true }} transition={{ delay: 0.3 }}>
            See All Reviews on Google →
          </motion.a>
        </section>

        {/* ─── CAREERS ─── */}
        <section id="careers" className="careers-section">
          <motion.div className="careers-header"
            initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.55 }}>
            <h3>💼 Work With Us</h3>
            <p className="careers-sub">
              Join a team that puts people first — across 8 pharmacies and growing.
              We're always looking for passionate, dedicated people who love caring for their community.
            </p>
          </motion.div>

          <div className="jobs-grid">
            {jobsData.map((job, i) => (
              <motion.div key={i} className="job-card"
                initial={{ opacity: 0, x: i % 2 === 0 ? -24 : 24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-30px" }}
                transition={{ duration: 0.45, delay: i * 0.07 }}>
                <div className="job-icon">{job.icon}</div>
                <div className="job-info">
                  <div className="job-title">{job.title}</div>
                  <div className="job-meta">
                    <span className="job-tag">{job.type}</span>
                    <span className="job-location">📍 {job.location}</span>
                  </div>
                </div>
                <a
                  href="https://wa.me/962781555855?text=Hi%2C%20I%27d%20like%20to%20apply%20for%20the%20position%20of%20"
                  target="_blank" rel="noopener noreferrer"
                  className="job-apply">
                  Apply
                </a>
              </motion.div>
            ))}
          </div>

          <motion.p className="careers-note"
            initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
            viewport={{ once: true }} transition={{ delay: 0.4 }}>
            Don't see your role? Reach out directly to HR — <strong>Dr. Rana Kallajo</strong> ·{" "}
            <a href="tel:+962781555855">+962 781 555 855</a>
          </motion.p>
        </section>

        {/* ─── SOCIALS ─── */}
        <section id="socials" className="socials-section">
          <motion.h3
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.55 }}>
            📱 Follow Us
          </motion.h3>
          <p className="socials-sub">Stay connected for health tips, offers, and updates.</p>

          <div className="socials-stickers">

            <motion.div
              className="holo-wrap holo-ig"
              initial={{ opacity: 0, y: 40, rotate: -6 }}
              whileInView={{ opacity: 1, y: 0, rotate: -4 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.22,1,0.36,1] }}>
              <a href="https://www.instagram.com/babhittapharmacy" target="_blank" rel="noopener noreferrer" className="holo-card">
                <div className="holo-layer" />
                <div className="holo-glare" />
                <div className="holo-edge" />
                <div className="holo-face">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" className="holo-logo" />
                  <div className="holo-info">
                    <span className="holo-name">Instagram</span>
                    <span className="holo-handle">@babhittapharmacy</span>
                  </div>
                  <div className="holo-badge">Follow ↗</div>
                </div>
              </a>
            </motion.div>

            <motion.div
              className="holo-wrap holo-fb"
              initial={{ opacity: 0, y: 40, rotate: 6 }}
              whileInView={{ opacity: 1, y: 0, rotate: 4 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1, ease: [0.22,1,0.36,1] }}>
              <a href="https://www.facebook.com/people/Bab-Hittah-Pharmacy/100064190018630/" target="_blank" rel="noopener noreferrer" className="holo-card">
                <div className="holo-layer" />
                <div className="holo-glare" />
                <div className="holo-edge" />
                <div className="holo-face">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" className="holo-logo holo-logo-fb" />
                  <div className="holo-info">
                    <span className="holo-name">Facebook</span>
                    <span className="holo-handle">Bab Hittah Pharmacy</span>
                  </div>
                  <div className="holo-badge">Follow ↗</div>
                </div>
              </a>
            </motion.div>

          </div>
        </section>

        {/* ─── CONTACT ─── */}
        <section id="contact" className="contact-section">
          <motion.div className="contact-inner"
            initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6 }}>

            {/* Left: brand block */}
            <div className="contact-left">
              <div className="contact-brand-mark">Bab Hitta</div>
              <div className="contact-brand-sub">Pharmacy</div>
              <p className="contact-tagline">
                Trusted pharmaceutical care since 2002 — across seven branches in Amman.
              </p>
              <a href="https://wa.me/962795550984" target="_blank" rel="noopener noreferrer" className="contact-wa-btn">
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="" />
                Chat on WhatsApp
              </a>
            </div>

            {/* Right: contact cards */}
            <div className="contact-cards">
              {contactList.map((item, i) => {
                const [role, name] = item.label.split(": ");
                return (
                <motion.div key={i} className="contact-card"
                  initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.1 }}>
                  <div>
                    <div className="contact-card-role">{role}</div>
                    <div className="contact-card-name">{name}</div>
                  </div>
                  <a href={`tel:${item.value}`} className="contact-card-btn">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 5.49 5.49l.97-.97a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                    Call Now
                  </a>
                </motion.div>
                );
              })}
            </div>
          </motion.div>
        </section>

        <footer>
          <span className="footer-mark">◆</span>
          <span>&copy; 2025 O.M🌸 &amp; Bab Hitta Pharmacy — All rights reserved.</span>
        </footer>
      </main>

      <motion.a href="https://wa.me/962795550984" target="_blank" rel="noopener noreferrer"
        className="whatsapp-float" aria-label="Chat on WhatsApp"
        initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.5, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.12, y: -3 }}>
        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
      </motion.a>
    </div>
  );
}
